import React, { useRef, useState, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import "./NewsPageFlip.css";

const Page = ({ item, index, total, side }) => {
  if (!item) return <div className="page-placeholder">No content</div>;

  const showLeftFold = side === "left" && index > 0;
  const showRightFold = side === "right" && index < total - 1;

  return (
    <div className="news-page">

      {/* Content */}
      {item.topText && <div className="page-top-tag">{item.topText}</div>}
      <div className="page-image-wrap">
        <img src={item.image} alt={item.title} className="page-image" />
      </div>

      <div className="page-info">
        <div className="page-title-row">
          {item.logo && <img className="page-logo" src={item.logo} alt="" />}
          <h3 className="page-title">{item.title}</h3>
          <p className="page-description">{item.bottomText}</p>
        </div>
      </div>

      {/* Only left outer page fold */}
      {showLeftFold && <div className="corner-fold left-fold"></div>}

      {/* Only right outer page fold */}
      {showRightFold && <div className="corner-fold right-fold"></div>}
    </div>
  );
};



export default function NewsPageFlip({ news = [] }) {
  const flipBook = useRef(null);
  const [page, setPage] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);

  const onFlip = (e) => setPage(e.data);

  // Detect mobile/tablet view
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sample data for Rialto Bridge
  const rialtoData = [
    {
      topText: "Historical Landmark",
      image: "https://images.unsplash.com/photo-1514890547357-a9ee288728e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=700&q=80",
      title: "Rialto Bridge",
      description: "The Rialto Bridge is the oldest of the four bridges spanning the Grand Canal in Venice and arguably the most famous landmark in the city.",
      features: [
        "Built between 1588 and 1591",
        "Designed by Antonio da Ponte",
        "Single stone arch spanning 28.8 meters",
        "24 shops along its span",
        "Iconic Venetian Renaissance architecture"
      ],
      featuresTitle: "Architectural Highlights"
    },
    {
      topText: "History & Construction",
      image: "https://images.unsplash.com/photo-1533873982433-02ff56d1079a?ixlib=rb-4.0.3&auto=format&fit=crop&w=700&q=80",
      title: "Historical Evolution",
      description: "The first crossing was a pontoon bridge built in 1181 by Nicolò Barattieri. It was originally called 'Ponte della Moneta' (Coin Bridge) due to the mint located at its eastern entrance.",
      features: [
        "1181: First pontoon bridge",
        "1255: First wooden bridge",
        "1444: Collapsed under crowd weight",
        "1524: Plans for stone bridge",
        "1591: Current bridge completed"
      ],
      featuresTitle: "Timeline"
    },
    {
      topText: "Venice Icon",
      image: "https://images.unsplash.com/photo-1553422256-e1c8b45dc5e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=700&q=80",
      title: "Cultural Significance",
      description: "For centuries, the Rialto Bridge has been the commercial and social heart of Venice, connecting the districts of San Marco and San Polo.",
      features: [
        "Featured in Shakespeare's 'The Merchant of Venice'",
        "Traditional market area nearby",
        "Major tourist attraction",
        "Symbol of Venetian engineering",
        "UNESCO World Heritage site"
      ],
      featuresTitle: "Cultural Impact"
    }
  ];

  const displayNews = news.length > 0 ? news : rialtoData;

  return (
    <section className="flip-section">
      <div className="flip-header">
        <h2>News & Milestones
</h2>
      </div>

      <div className="flip-container">
        <HTMLFlipBook
          width={isMobileView ? 350 : 700}
          height={isMobileView ? 500 : 550}
          size="stretch"
          minWidth={300}
          maxWidth={isMobileView ? 400 : 1000}
          minHeight={400}
          maxHeight={isMobileView ? 600 : 800}
          maxShadowOpacity={0.3}
          usePortrait={isMobileView}
          showCover={false}
          mobileScrollSupport={true}
          drawShadow={!isMobileView}
          ref={flipBook}
          onFlip={onFlip}
          className={isMobileView ? "single-page-mode" : ""}
        >
          {displayNews.map((item, i) => (
  <div
    key={i}
    className={`page ${i % 2 === 0 ? "left" : "right"}`}
  >
    <Page
      item={item}
      index={i}
      total={displayNews.length}
      side={i % 2 === 0 ? "left" : "right"}
    />
  </div>
))}


        </HTMLFlipBook>
      </div>

      {!isMobileView && (
        <div className="flip-controls">
          <button
            onClick={() => flipBook.current.pageFlip().flipPrev()}
            className="flip-btn"
            disabled={page <= 0}
          >
            ⟵ Prev
          </button>

          <div className="page-indicator">
            {Math.min(page + 1, displayNews.length)} / {displayNews.length}
          </div>

          <button
            onClick={() => flipBook.current.pageFlip().flipNext()}
            className="flip-btn"
            disabled={page >= displayNews.length - 1}
          >
            Next ⟶
          </button>
        </div>
      )}
    </section>
  );
}